import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Play } from "lucide-react";
import { api, errMsg } from "./api";
import { Shell, Panel, Spinner } from "./ui";

export default function Videos() {
  const [videos, setVideos] = useState(null);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    api.get("/videos").then((r) => setVideos(r.data.videos)).catch((e) => toast.error(errMsg(e)));
  }, []);

  if (!videos) return <Shell title="Training videos" back="/staff"><Spinner /></Shell>;

  const list = videos.filter((v) => !filter || `${v.title} ${v.zone || ""} ${v.category || ""}`.toLowerCase().includes(filter.toLowerCase()));

  return (
    <Shell title="Training videos" back="/staff">
      <input data-testid="video-search" value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Search by task, zone or brand…"
        className="w-full min-h-[48px] rounded-xl bg-black/40 border border-white/15 px-4 text-white text-base outline-none focus:border-[#ff2e4d] placeholder:text-white/30 mb-4" />
      {list.length === 0 ? (
        <Panel className="p-6 text-center" data-testid="videos-empty">
          <p className="text-white/60 font-semibold">No training videos published yet</p>
          <p className="text-white/35 text-sm mt-1">Your manager will add them here. Tasks still work from their written instructions.</p>
        </Panel>
      ) : (
        <div className="space-y-2.5" data-testid="video-list">
          {list.map((v) => (
            <a key={v.video_id} href={v.url} target="_blank" rel="noreferrer" data-testid={`video-item-${v.video_id}`} className="block">
              <Panel className="p-4 flex items-center gap-4 active:scale-[0.99] transition">
                <span className="h-11 w-11 rounded-full bg-[#ff2e4d]/15 text-[#ff2e4d] flex items-center justify-center shrink-0"><Play size={18} /></span>
                <span className="min-w-0">
                  <span className="block font-semibold truncate">{v.title}</span>
                  <span className="block text-xs text-white/45">{[v.zone, v.category].filter(Boolean).join(" · ") || "General"}</span>
                </span>
              </Panel>
            </a>
          ))}
        </div>
      )}
    </Shell>
  );
}
